// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-chart {
  display: inline-block;
  width: 100%;
  height: 100%;
  overflow-x: auto;
}
.fi-chart .chart-wrapper {
  height: 100%;
  width: 100%;
}
.fi-chart .chart-wrapper.chart-small {
  display: inline-block;
  vertical-align: baseline;
  height: 100%;
}
.fi-chart .chart-legend-container {
  line-height: 16px;
  display: inline-block;
  height: 90%;
  overflow: auto;
  width: 45%;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chart/fi-chart.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AACJ;AACI;EACI,YAAA;EACA,WAAA;AACR;AACQ;EACI,qBAAA;EACA,wBAAA;EACA,YAAA;AACZ;AAGI;EACI,iBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,UAAA;EACA,sBAAA;AADR","sourcesContent":[".fi-chart {\r\n    display: inline-block;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow-x: auto;\r\n\r\n    .chart-wrapper {\r\n        height: 100%;\r\n        width: 100%;\r\n\r\n        &.chart-small {\r\n            display: inline-block;\r\n            vertical-align: baseline;\r\n            height: 100%;\r\n        }\r\n    }\r\n\r\n    .chart-legend-container {\r\n        line-height: 16px;\r\n        display: inline-block;\r\n        height: 90%;\r\n        overflow: auto;\r\n        width: 45%;\r\n        vertical-align: middle;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
